module.exports = __webpack_public_path__ + "img/ccdspos.15b9369c.png";